import { render, staticRenderFns } from "./KeywordsWhitelist.vue?vue&type=template&id=c3099804&scoped=true"
import script from "./KeywordsWhitelist.vue?vue&type=script&lang=js"
export * from "./KeywordsWhitelist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3099804",
  null
  
)

export default component.exports